import type { DistanceFragment } from '@ps/isp-web-services-types';
import React from 'react';

interface Props {
  distance?: Omit<DistanceFragment, 'totalFurlongs' | 'totalMeters'>;
}

const HorseRaceDistance: React.FC<Props> = ({ distance }) => {
  if (!distance) return null;
  const { miles, furlongs } = distance;
  if (!miles && !furlongs) return null;

  const milesValue = miles > 0 ? `${miles}m` : '';
  const furlongsValue = furlongs > 0 ? `${furlongs}f` : '';

  return (
    <span>
      {milesValue}
      {furlongsValue}
    </span>
  );
};

export { HorseRaceDistance };
